module.exports = __webpack_public_path__ + "img/a02.4569a4af.png";